import { z } from 'zod';

/**
 * Data classification carried by every knowledge item, source document and LLM context.
 * Ordered from least to most sensitive. Provider eligibility is configured per classification
 * (see docs/08-SECURITY.md, "LLM data egress"). RESTRICTED is denied to external providers by default.
 */
export const CLASSIFICATIONS = ['PUBLIC', 'INTERNAL', 'CONFIDENTIAL', 'RESTRICTED'] as const;
export const Classification = z.enum(CLASSIFICATIONS);
export type Classification = z.infer<typeof Classification>;

const RANK: Record<Classification, number> = {
  PUBLIC: 0,
  INTERNAL: 1,
  CONFIDENTIAL: 2,
  RESTRICTED: 3,
};

/** Returns true when `value` is at most as sensitive as `ceiling`. */
export function classificationWithin(value: Classification, ceiling: Classification): boolean {
  return RANK[value] <= RANK[ceiling];
}

/** Highest classification of a set; empty sets default to the most restrictive (fail closed). */
export function maxClassification(values: readonly Classification[]): Classification {
  if (values.length === 0) return 'RESTRICTED';
  return values.reduce((a, b) => (RANK[b] > RANK[a] ? b : a));
}
